<div
  class="tile hud-title"
  (click)="onContextMenuSelect({ text: 'View Data' })"
>
  <div class="metric-card">
    <div class="metric-header">
      <h3>New Customers</h3>
    </div>
    <!-- Use partnerOrgCount data if available, otherwise fall back to the old inputs -->
    <div class="metric-value">
      {{ partnerOrgCount().org_count_current !== null ? partnerOrgCount().org_count_current : 0 }}
    </div>
    <div
      class="metric-comparison"
      [class.up]="
        (partnerOrgCount().org_count_current !== null ? partnerOrgCount().org_count_current : 0) >
        (partnerOrgCount().org_count_previous !== null ? partnerOrgCount().org_count_previous : 0)
      "
      [class.down]="
        (partnerOrgCount().org_count_current !== null ? partnerOrgCount().org_count_current : 0) <
        (partnerOrgCount().org_count_previous !== null ? partnerOrgCount().org_count_previous : 0)
      "
      [class.equal]="
        (partnerOrgCount().org_count_current !== null ? partnerOrgCount().org_count_current : 0) ===
        (partnerOrgCount().org_count_previous !== null ? partnerOrgCount().org_count_previous : 0)
      "
    >
      @if (
        (partnerOrgCount().org_count_current !== null ? partnerOrgCount().org_count_current : 0) >
        (partnerOrgCount().org_count_previous !== null ? partnerOrgCount().org_count_previous : 0)
      ) {
        <span>↑</span>
      }
      @if (
        (partnerOrgCount().org_count_current !== null ? partnerOrgCount().org_count_current : 0) <
        (partnerOrgCount().org_count_previous !== null ? partnerOrgCount().org_count_previous : 0)
      ) {
        <span>↓</span>
      }
      {{
        partnerOrgCount().org_count_pct_change !== undefined
          ? Math.abs(partnerOrgCount().org_count_pct_change)
          : (Math.abs(
              (((partnerOrgCount().org_count_current !== null ? partnerOrgCount().org_count_current : 0) -
                (partnerOrgCount().org_count_previous !== null ? partnerOrgCount().org_count_previous : 0)) /
                (partnerOrgCount().org_count_previous !== null ? partnerOrgCount().org_count_previous : 1)) *
                100
            ) | number: '1.1-1')
      }}% vs Last Period
    </div>
    <div class="metric-subtext">
      Previous: {{ partnerOrgCount().org_count_previous !== null ? partnerOrgCount().org_count_previous : 0 }}
    </div>
  </div>
</div>

<kendo-dialog
  *ngIf="showPopup"
  (close)="close()"
  [width]="'95vw'"
  [height]="'90vh'"
  [minWidth]="'800px'"
  [maxWidth]="'1400px'"
>
  <kendo-dialog-titlebar>View Data</kendo-dialog-titlebar>
  <kendo-grid
    class="mxh-80v"
    [filterable]="true"
    [data]="gridService | async"
    [pageable]="{
      buttonCount: 5,
      info: true,
      type: 'numeric',
      pageSizes: [25, 50, 100, 200]
    }"
    [pageSize]="gridService.state.take"
    [skip]="gridService.state.skip"
    [(filter)]="gridService.state.filter"
    [loading]="gridService.loading"
    (dataStateChange)="gridService.onStateChange($event)"
    [sort]="this.gridService.state.sort"
    [sortable]="true"
    [resizable]="true"
  >
    <ng-template kendoGridToolbarTemplate>
      <button
        type="button"
        kendoGridExcelCommand
        class="cyflare-btn-secondary"
      >
        Export to Excel
      </button>
    </ng-template>
    <kendo-grid-column
      field="name"
      title="Customer Name"
    ></kendo-grid-column>
    <kendo-grid-column
      field="industry_name"
      title="Industry"
    ></kendo-grid-column>
    <kendo-grid-column
      field="user_count"
      title="	#  of Users"
    ></kendo-grid-column>
    <kendo-grid-column
      field="created_at"
      title="Date Activated"
      [width]="200"
      >
      <ng-template
          kendoGridFilterCellTemplate
          let-filter
          let-column="column"
        >
          <kendo-grid-date-filter-cell
            [column]="column"
            [filter]="filter"
            [operators]="dateFilterOperators"
          ></kendo-grid-date-filter-cell>
        </ng-template>
      </kendo-grid-column>
    <kendo-grid-column
      field="parent_name"
      title="Parent Account Name"
    ></kendo-grid-column>
    <kendo-grid-excel
      fileName="customers-metrics-data.xlsx"
      [fetchData]="allData"
    ></kendo-grid-excel>
  </kendo-grid>
</kendo-dialog>